import { Link } from 'react-router-dom';
import { promoBanners } from '@/data/homeContent';

/** Fila informativa tipo mostrador — sin cards de colores. */
export function InfoStrip() {
  return (
    <section className="border-y border-surface-200 bg-surface-50">
      <div className="container-app">
        <dl className="grid divide-y divide-surface-200 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
          {promoBanners.map((b) => (
            <div key={b.title} className="px-0 py-4 sm:px-6 sm:py-5">
              <dt className="text-sm font-semibold text-surface-900">{b.title}</dt>
              <dd className="mt-1 text-sm leading-snug text-surface-600">{b.desc}</dd>
              <dd className="mt-2">
                <Link to={b.to} className="text-sm font-medium text-brand-700 hover:underline">
                  {b.linkText}
                </Link>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
